import { InjectionToken } from "@angular/core";

export interface SurfaceReportsApiConfig {
	portalBackendUrl?: string;
	portalApiKey?: string;
}

export const SURFACE_REPORTS_API_CONFIG = new InjectionToken<SurfaceReportsApiConfig>("SURFACE_REPORTS_API_CONFIG");
